import React from "react";
import classNames from "classnames";
import { OrderVehicle } from "../vehicleData";
import radioOff from "../../../static/ride-order/ic_check.svg";
import radioOn from "../../../static/ride-order/ic_checked.svg";
import styles from "./ElitVehiclePanel.module.scss";

export type ElitVehicleCardLabels = {
  luggageLabel: string;
  passengersLabel: string;
  transferLabel: string;
  hourlyRateLabel: string;
  dailyRateLabel: string;
  pricePerKmLabel: string;
  minHoursLabel: string;
};

type ElitVehicleCardProps = {
  vehicle: OrderVehicle;
  selected: boolean;
  labels: ElitVehicleCardLabels;
  onSelect: () => void;
};

const ElitVehicleCard: React.FC<ElitVehicleCardProps> = ({
  vehicle,
  selected,
  labels,
  onSelect,
}) => {
  const minHoursNote = labels.minHoursLabel.replace("{hours}", String(vehicle.minHours));

  return (
    <button
      type="button"
      className={classNames(styles.carCard, {
        [styles.carCardSelected]: selected,
      })}
      onClick={onSelect}
      aria-pressed={selected}
    >
      <div className={styles.carCardInner}>
        <img className={styles.carRadio} src={selected ? radioOn : radioOff} alt="" aria-hidden />

        <div className={styles.carImageCol}>
          <img className={styles.carPhoto} src={vehicle.image} alt={vehicle.name} />
          <span className={styles.priceBadge}>
            {labels.transferLabel} {vehicle.transferPrice}
          </span>
        </div>

        <div className={styles.carBody}>
          <div className={styles.carHeader}>
            <span className={styles.carBrand}>{vehicle.brand}</span>
            <h3 className={styles.carName}>{vehicle.name}</h3>
            <p className={styles.carModel}>{vehicle.model}</p>
            <p className={styles.carSpecs}>{vehicle.specs}</p>
          </div>

          <ul className={styles.pricingList}>
            <li className={styles.pricingItem}>
              <span className={styles.pricingLabel}>{labels.transferLabel}</span>
              <span className={styles.pricingValue}>{vehicle.transferPrice}</span>
            </li>
            <li className={styles.pricingItem}>
              <span className={styles.pricingLabel}>{labels.hourlyRateLabel}</span>
              <span className={styles.pricingValue}>
                {vehicle.hourlyRate}
                <span className={styles.pricingMeta}> ({minHoursNote})</span>
              </span>
            </li>
            <li className={styles.pricingItem}>
              <span className={styles.pricingLabel}>{labels.dailyRateLabel}</span>
              <span className={styles.pricingValue}>{vehicle.dailyRate}</span>
            </li>
            <li className={styles.pricingItem}>
              <span className={styles.pricingLabel}>{labels.pricePerKmLabel}</span>
              <span className={styles.pricingValue}>{vehicle.pricePerKm}</span>
            </li>
          </ul>

          <div className={styles.capacityRow}>
            <div className={styles.capacityChip}>
              <span className={classNames(styles.capacityIcon, styles.capacityIconLuggage)} aria-hidden />
              <span className={styles.capacityText}>{labels.luggageLabel}</span>
              <span className={styles.capacityValue}>{vehicle.maxLuggage}</span>
            </div>
            <div className={styles.capacityChip}>
              <span className={classNames(styles.capacityIcon, styles.capacityIconPassenger)} aria-hidden />
              <span className={styles.capacityText}>{labels.passengersLabel}</span>
              <span className={styles.capacityValue}>{vehicle.maxPassengers}</span>
            </div>
          </div>
        </div>
      </div>
    </button>
  );
};

export default ElitVehicleCard;
